var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-wrapper-wallet',{attrs:{"total-left-col-items":1,"total-right-col-items":2},scopedSlots:_vm._u([{key:"leftColItem1",fn:function(){return [_c('module-send-offline')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }